// src/components/Login.tsx
import React, { useState, FormEvent } from "react";
import { signInWithEmailAndPassword } from "firebase/auth"; // Import FirebaseError
import { auth } from "../fbserve"; // Adjust path if your firebase.ts is elsewhere
import { useNavigate } from "react-router-dom"; // For navigation after login

function Login() {
  // Explicitly define return type for functional component
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    // Type the event as FormEvent
    e.preventDefault(); // Prevent default form submission

    setError(""); // Clear previous errors
    setLoading(true); // Set loading state

    try {
      await signInWithEmailAndPassword(auth, email, password);
      // If successful, navigate to a protected route (e.g., home page)
      navigate("/");
    } catch (error: any) {
      // Catch any error first
      const firebaseError = error; // Cast to FirebaseError for specific error codes
      // Handle various Firebase authentication errors
      switch (firebaseError.code) {
        case "auth/user-not-found":
          setError("No user found with this email.");
          break;
        case "auth/wrong-password":
          setError("Incorrect password.");
          break;
        case "auth/invalid-email":
          setError("Invalid email address.");
          break;
        case "auth/user-disabled":
          setError("This account has been disabled.");
          break;
        default:
          setError("Failed to log in: " + firebaseError.message);
      }
      console.error("Login error:", firebaseError);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <section>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            } // Type the event
            required
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPassword(e.target.value)
            } // Type the event
            required
          />
        </div>
        <button className="btn" type="submit" disabled={loading}>
          {loading ? "Logging In..." : "Log In"}
        </button>
      </form>
    </section>
  );
}

export default Login;
